






























import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import {
  ILeadProviderData,
  ILeadProviderMethods
} from "@/models/providers/lead";

@Component({
  components: {
    "tickets-table": () =>
      import("@/components/app/global/tickets/ticketsTable.vue")
  }
})
export default class AdminLeadTicketsView extends Vue {
  // Injected

  @Inject({ from: "leadProvider" })
  public readonly $leadProvider!: () => ILeadProviderData;

  @Inject({ from: "leadMethods" })
  public readonly $leadMethods!: ILeadProviderMethods;

  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => any;

  // Computed

  public get $leadData() {
    return this.$leadProvider();
  }

  public get manualFilters(): Record<string, any> {
    if (this.$leadData.isStaged) return { with_staged_imports: 1 };
    return {};
  }
}
